/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrandDto
 */
export interface BrandDto {
    /**
     * Brand which is in use by organization or service provider
     * @type {string}
     * @memberof BrandDto
     */
    id?: string;
    /**
     * A service mark, trademark, product name, or similar
     * @type {string}
     * @memberof BrandDto
     */
    name?: string;
    /**
     * A CSS color using # and hex for RGB. Subtly changes the color of limited elements in UI
     * @type {string}
     * @memberof BrandDto
     */
    accentColor?: string;
    /**
     * A CSS for branded emails
     * @type {string}
     * @memberof BrandDto
     */
    emailCss?: string;
    /**
     * A small logo can be downloaded
     * @type {string}
     * @memberof BrandDto
     */
    logoUrl?: string;
    /**
     * Where someone can go to read brochure-like content about this brand. Clicking the brand logo takes user to this URL
     * @type {string}
     * @memberof BrandDto
     */
    promoUrl?: string;
}

/**
 * Check if a given object implements the BrandDto interface.
 */
export function instanceOfBrandDto(value: object): boolean {
    return true;
}

export function BrandDtoFromJSON(json: any): BrandDto {
    return BrandDtoFromJSONTyped(json, false);
}

export function BrandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'accentColor': json['accentColor'] == null ? undefined : json['accentColor'],
        'emailCss': json['emailCss'] == null ? undefined : json['emailCss'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'promoUrl': json['promoUrl'] == null ? undefined : json['promoUrl'],
    };
}

export function BrandDtoToJSON(value?: BrandDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'accentColor': value['accentColor'],
        'emailCss': value['emailCss'],
        'logoUrl': value['logoUrl'],
        'promoUrl': value['promoUrl'],
    };
}

